module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAMCAYAAABbayygAAAAAXNSR0IArs4c6QAAADlJREFUGBljYACC////dwIxCMwHYiaQGFYAkoQqAlJDUnEnyGO4fYjV20iCRIUAnRWBnAe0kmAUAgCtFrPqbRElqgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/apps/portfolio/assets/renqi.png
// module id = 2252
// module chunks = 2